import { customEvent, dispatchCustomEvent } from './custom-event';

export const notify = {
  that: type => (obj = { detail: null }) => (elem = document) =>
    dispatchCustomEvent(customEvent(type)(obj))(elem),

  when: type => fn => document.addEventListener(type, fn),

  noLonger: type => fn => document.removeEventListener(type, fn),
};
